(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('WeatherForecastPanelCtrl', WeatherForecastPanelController);

  WeatherForecastPanelController.$inject = [
    '$scope',
    'DadosMeteorologicosService',
    'LoadingService',
    'MessagesService'
  ];

  /**
   * Este caso, como os dados são exibidos no botão que abre o painel, a variável
   * que guarda os dados está presente no $scope pai, acessível aqui como:
   *    $scope.data
   */
  function WeatherForecastPanelController($scope, DadosMeteorologicosService, LoadingService, MessagesService) {
    const vm = this;

    //////////////////////////////////////////
    // Bindable methods
    vm.iconClass = iconClass;
    vm.isDifferentDate = isDifferentDate;
    vm.textDayLabel = textDayLabel;
    vm.textCardTime = textCardTime;
    vm.textRain = textRain;

    //////////////////////////////////////////
    // Function declarations
    function iconClass(icon) {
      return `icon-weather-${icon.substr(0, icon.length - 1)}`;
    }

    function isDifferentDate(item, index) {
      return index === 0 || !moment(item.dt_txt).isSame($scope.data.list[index - 1].dt_txt, 'day');
    }

    function textDayLabel(item) {
      return moment(item.dt_txt).format('DD [de] MMMM');
    }

    function textCardTime(item) {
      return moment(item.dt_txt).format('LT');
    }

    function textRain(item) {
      return Math.max(item.rain['3h'], 0.1);
    }

    function loadData() {
      LoadingService.showLoading();
      return DadosMeteorologicosService.previsaoDoTempo($scope.$root.currentPropriedade.id)
        .then(({ data }) => $scope.$emit('loadedWeatherForecast', data))
        .catch((error) => {
          console.error(error);
          $scope.$emit('loadedWeatherForecast', 'error');
          MessagesService.alert('Não foi possível carregar a previsão do tempo');
        })
        .finally(LoadingService.hideLoading);
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$root.initialize
      .then(() => {
        if ($scope.data !== 'error' && $scope.data !== 'loading' && !($scope.data || {}).city) {
          return loadData();
        }
      })
      .catch($scope.$root.errorRootInitialize);
  }
}());
